<template>
	<v-dialog v-model="dialog" persistent fullscreen class="pb-6">
		<v-card>
			<v-card-title
				:class="$vuetify.breakpoint.smAndDown ? 'caption pa-1' : ''"
			>
				<v-col cols="10" sm="8" md="8" class="mt-2">
					{{ $route.query.event }}
				</v-col>
				<v-spacer></v-spacer>
				<v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
			</v-card-title>
			<v-card-subtitle
				:class="
					$vuetify.breakpoint.smAndDown ? 'pt-2 pb-0 caption' : 'pt-2 pb-0 ml-5'
				"
				>{{ $route.query.date }} {{ $gmt() }}</v-card-subtitle
			>
			<v-card-subtitle
				:class="
					$vuetify.breakpoint.smAndDown ? 'pt-2 pb-0 caption' : 'pt-2 pb-0 ml-5'
				"
				>{{ $route.query.tournament }}</v-card-subtitle
			>

			<v-card-text class="mt-4">
				<v-row class="d-flex">
					<v-col cols="12" lg="6" md="6" sm="6">
						<SelectEventStage />
					</v-col>
					<v-col cols="12" lg="6" md="6" sm="6">
						<SelectStatusBet />
					</v-col>
				</v-row>
				<v-row class="mb-3">
					<v-col
						cols="12"
						lg="3"
						md="3"
						sm="4"
						v-show="datatableItems.length > 0"
						class="ml-2 mt-2 h5"
					>
						{{ $t("totalBets") }}: {{ datatableItems.length }}
					</v-col>
					<v-spacer></v-spacer>
					<v-col
						:class="
							$vuetify.breakpoint.smAndDown
								? ''
								: 'pl-0' || $vuetify.breakpoint.smAndUp
								? 'pl-3'
								: ''
						"
						cols="12"
						lg="3"
						md="3"
						sm="4"
					>
						<v-text-field
							v-model="search"
							append-icon="mdi-magnify"
							:label="$t('search')"
							single-line
							hide-details
							dense
							solo-inverted
							clearable
						></v-text-field>
					</v-col>
				</v-row>

				<v-divider class="mt-2"></v-divider>

				<v-data-table
					v-if="datatableItems.length > 0 || loading"
					:headers="headers"
					:items="datatableItems"
					:search="search"
					class="elevation-2"
					:footer-props="{
						'items-per-page-text': this.$t('rowsPerPage'),
					}"
				>
					<template v-slot:item.date="{ item }">
						<span class="caption">{{ item.date }}</span>
					</template>

					<template v-slot:item.punter="{ item }">
						<span class="caption">{{ item.punter }}</span>
					</template>

					<template v-slot:item.date_cancellation="{ item }">
						<span class="caption">{{ item.date_cancellation }}</span>
					</template>

					<template v-slot:item.id="{ item }">
						<v-btn @click="$copy(item.id)" x-small>{{ item.id }}</v-btn>
					</template>

					<template v-slot:item.amount="{ item }">
						<span class="caption">{{ item.amount }}</span>
					</template>

					<template v-slot:item.n_events="{ item }">
						<span class="caption">{{ item.n_events }}</span>
					</template>

					<template v-slot:item.factor_bet="{ item }">
						<span class="caption">{{ item.factor_bet }}</span>
					</template>

					<template v-slot:item.prize="{ item }">
						<span class="caption">{{ item.prize }}</span>
					</template>

					<template v-slot:item.paid="{ item }">
						<v-icon :color="item.paid == 1 ? 'green' : 'orange'">{{
							formatPaid(item.paid)
						}}</v-icon>
					</template>

					<template v-slot:item.result_bet="{ item }">
						<div
							class="font-weight-black"
							v-html="$infoTable.conference(item.result_bet, item.status_bet)"
						></div>
					</template>

					<!-- <template v-slot:item.events="{ item }">
						<span class="caption">{{ item.events }}</span>
					</template> -->

					<!-- <template v-slot:item.scheduled="{ item }">
						<span class="caption">{{ item.scheduled }}</span>
					</template> -->
				</v-data-table>
				<div
					class="mt-4 text-center"
					:class="$vuetify.breakpoint.smAndDown ? '' : 'subtitle-1'"
					v-else
				>
					{{ $t("noBetsFountForThisEvent") }}
				</div>
			</v-card-text>

			<!-- Resume Perído -->
			<v-card-text>
				<div class="mt-1" v-if="resume.prizeTotal && resume.amountTotal">
					<v-row>
						<v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
						<v-col cols="12" xs="12" sm="6" md="4">
							<v-divider></v-divider>
							<v-card class="pa-3">
								<div class="subtitle-1 mb-2">
									{{ $t("justResume") }}
								</div>
								<v-simple-table>
									<template v-slot:default>
										<tbody>
											<tr>
												<td>{{ $t("betAmount") }}</td>
												<td class="text-right green--text darken-4">
													{{ resume.amountTotal }}
												</td>
											</tr>
											<tr>
												<td>{{ $t("paidPremiuns") }}</td>
												<td class="text-right red--text darken-4">
													{{ resume.prizePaid || "0.00" }}
												</td>
											</tr>
											<tr>
												<td>{{ $t("passibleAwards") }}</td>
												<td class="text-right orange--text darken-4">
													{{ resume.prizeNoPaid || "0.00" }}
												</td>
											</tr>
											<tr>
												<td>{{ $t("totalPrizes") }}</td>
												<td class="text-right grey--text darken-4">
													{{ resume.prizeTotal }}
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-card>
						</v-col>
					</v-row>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
	import SelectEventStage from "@/components/common/filters/SelectEventStage";
	import SelectStatusBet from "@/components/common/filters/SelectStatusBet";
	export default {
		name: "AdministratorBetPlacedReport",
		components: {
			SelectEventStage,
			SelectStatusBet,
		},
		data: () => ({
			search: "",
			datatableItems: [],
			resume: {},
			loading: false,
		}),
		computed: {
			headers() {
				if (this.statusBet == 1) {
					return [
						{
							text: this.$t("code"),
							value: "id",
							sortable: false,
							align: "center",
						},
						{
							text: this.$t("betDate"),
							value: "data",
							sortable: false,
							align: "center",
						},
						{
							text: this.$t("player"),
							value: "apostador",
							sortable: false,
							align: "center",
						},
						{
							text: this.$t("betAmount"),
							value: "value",
							sortable: false,
							align: "center",
						},
						{
							text: this.$t("totalOdds"),
							value: "factor_bet",
							sortable: false,
							align: "center",
						},
						{
							text: this.$t("passibleAwards"),
							value: "prize",
							sortable: false,
							align: "center",
						},
						{
							text: this.$t("betPaid"),
							value: "paid",
							sortable: false,
							align: "center",
						},
						{
							text: this.$t("result"),
							value: "result_bet",
							sortable: false,
							align: "center",
						},
					];
				} else {
					return [
						{
							text: this.$t("code"),
							value: "id",
							sortable: false,
							align: "center",
						},
						{
							text: this.$t("betDate"),
							value: "data",
							sortable: false,
							align: "center",
						},
						{
							text: this.$t("cancellation"),
							value: "date_cancellation",
							sortable: false,
							align: "center",
						},
						{
							text: this.$t("player"),
							value: "apostador",
							sortable: false,
							align: "center",
						},
						{
							text: this.$t("betAmount"),
							value: "value",
							sortable: false,
							align: "center",
						},
						{
							text: this.$t("totalOdds"),
							value: "factor_bet",
							sortable: false,
							align: "center",
						},
						{
							text: this.$t("possibleReturn"),
							value: "prize",
							sortable: false,
							align: "center",
						},
					];
				}
			},

			dialog() {
				return this.$store.state.showDialogBetPlacedReport;
			},
			statusBet() {
				return this.$store.state.filters.selectStatusBet.status;
			},
			eventStage() {
				return this.$store.state.filters.selectEventStage.value;
			},
			eventIdByRoute() {
				return this.$route.params.id;
			},
		},
		mounted() {
			this.getBetByEvents();
		},
		watch: {
			// Observa a mudança do select Etapa do evento e dispara o get
			eventStage(val) {
				// o if impede que um get seja feito quando a dialog é fechada
				if (!this.dialog) return;
				val && this.getBetByEvents();
			},
			// Com a Etapa do evento selecionada, observa o select de status de aposta e dispara o get
			statusBet(val) {
				if (val || val == 0) {
					this.getBetByEvents();
				}
			},
		},
		methods: {
			reset() {
				this.datatableItems = [];
				this.resume = {};
			},
			closeDialog() {
				this.$router.go(-1);
				// Ao fechar a dialog, armazena prematch no store, para evitar que o dado persista ao mundar de evento
				this.$store.commit("showDialogBetPlacedReport", false);
				// this.$store.commit("setSelectEventStage", "prematch");
			},

			async getBetByEvents() {
				this.loading = true;
				if (this.$route.params.id == undefined) {
					this.closeDialog();
					return;
				}
				this.reset();
				try {
					const body = {
						event_id: this.$route.params.id,
						status: this.statusBet,
						match_type: this.eventStage,
					};
					const response = await this.$request.post(
						"/administrator/events/betByEvents",
						body
					);
					if (!response.dados) return;
					this.datatableItems = response.dados;
					this.datatableItems.forEach((item) => {
						item.data = new Date(item.data).toLocaleString();
						item.amount = item.value;

						if (item.date_cancellation != "") {
							item.date_cancellation = new Date(
								item.date_cancellation
							).toLocaleString();
						}
					});
					this.resume = this.$resume.resumeBet(this.datatableItems);
				} catch {
					(error) => {
						error;
					};
				} finally {
					this.loading = false;
				}
			},
			formatPaid(val) {
				const format = val == 1 ? "mdi-check" : "mdi-close";
				return format;
			},
		},
	};
</script>
